import { Component, Input, OnDestroy, OnInit } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { Subscription } from "rxjs"
import { ALIASED_FACETS } from "../../models/constants"
import { SearchInfoModel } from "../../models/searchInfo.model"
import { BrowsingService } from "../../services/browsing.service"
import { FacetingService } from "../../services/faceting.service"
import { SearchingService } from "../../services/searching.service"

@Component({
    selector: "app-applied-filters",
    templateUrl: "./applied-filters.component.html",
    styleUrls: ["./applied-filters.component.scss"],
})
export class AppliedFiltersComponent implements OnInit, OnDestroy {
    public appliedFilters = []
    public subscriptions: Subscription[] = []
    @Input() public searchInfo: SearchInfoModel
    @Input() public shouldBeDisplayed?: boolean = true

    constructor(
        private facetingService: FacetingService,
        private browsingService: BrowsingService,
        private route: ActivatedRoute,
        private router: Router,
        private searchingService: SearchingService
    ) {}

    public ngOnInit() {
        this.subscriptions.push(
            this.searchingService.availableFacetsChanged.subscribe((data: any) => {
                this.appliedFilters = []
                this.crossReference(data, this.facetingService.appliedFilters)
            })
        )
    }

    public crossReference(availableFacets, appliedFacets) {
        const inactives = []
        if (appliedFacets.length) {
            appliedFacets.map((filter, index) => {
                const key = filter.split(":")[0]
                const value =
                    ALIASED_FACETS.includes(key) && availableFacets.hasOwnProperty(key)
                        ? Number(filter.split(":")[1])
                        : filter.split(":")[1]
                const av = availableFacets.hasOwnProperty(key)
                    ? availableFacets[key].filter((elem) => elem.id === value)
                    : []
                if (av.length) {
                    this.appliedFilters.push({
                        index,
                        filter,
                        title: av[0].title,
                        active: true,
                    })
                } else {
                    inactives.push({
                        index,
                        filter,
                        title: filter,
                        active: false,
                    })
                }
            })
        }
        this.getInactiveValues(inactives)
    }

    private getInactiveValues(inactives = []) {
        inactives.map((inactive) => {
            if (inactive.title.match("subject")) {
                const chValue: number = +inactive.filter.substring(
                    inactive.filter.indexOf(":") + 1,
                    inactive.filter.length
                )
                this.browsingService.getNode(chValue).subscribe((node: any) => {
                    inactive.title = node.title
                })
            } else if (inactive.title.match("standard")) {
                const stValue = inactive.filter.substring(
                    inactive.filter.indexOf(":") + 1,
                    inactive.filter.length
                )
                this.searchingService.getStandardDetails(stValue).subscribe((standard: any) => {
                    inactive.title = standard.displayName
                })
            } else if (inactive.title.match("brand_id")) {
                const brandId = inactive.filter.substring(
                    inactive.filter.indexOf(":") + 1,
                    inactive.filter.length
                )
                this.searchingService.getBrandDetails(brandId).subscribe((brand: any) => {
                    inactive.title = brand.display_name
                })
            } else if (inactive.title.match("cp")) {
                const cpId = inactive.filter.substring(
                    inactive.filter.indexOf(":") + 1,
                    inactive.filter.length
                )
                this.searchingService.searchInfo.subscribe((data) => {
                    const contentProject = data.cpFilter.filter((cp) => cp.id === +cpId)[0]
                    inactive.title = contentProject ? contentProject.label : ""
                })
            } else if (inactive.title.match("cs|ct")) {
                const [type, id] = inactive.title.split(":")
                this.searchingService.searchInfo.subscribe((searchInfo) => {
                    // TODO there's gotta be a prettier way of doing this
                    for (const cf of searchInfo.customFilterObjects) {
                        for (const cs of cf.children) {
                            if (cs.type === type && cs.id === +id) {
                                inactive.title = cs.title
                                break
                            }
                            for (const ct of cs.children) {
                                if (ct.type === type && ct.id === +id) {
                                    inactive.title = ct.title
                                    break
                                }
                            }
                        }
                    }
                })
            } else {
                inactive.title = inactive.title
                    .substring(inactive.filter.indexOf(":") + 1, inactive.filter.length)
                    .replace(/\+/g, " ")
            }
            this.appliedFilters.push(inactive)
        })
    }

    public onClearFilter(filter: string) {
        this.facetingService.removeFilter(filter, this.route)
    }

    public onClearCollectionFilter() {
        return this.goToSearch(true)
    }

    public onClearAllFilters() {
        this.facetingService.clearFilters(this.route)
    }

    public goToSearch(keepFilters: boolean = false) {
        if (keepFilters) {
            this.router.navigate(["/search"], { queryParamsHandling: "merge" })
        } else {
            this.router.navigate(["/search"])
        }
        return false
    }

    public ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
